const $ = window.$

export default function () {
  $('.export-campaign').on('click', (e) => {
    e.preventDefault()
    const $lnk = $(e.currentTarget)
    $.get($lnk.prop('href'))
  })
}
